export const environment = {
    production: false,
    ApiBaseUrl: "https://appsvc-remitter-toolsapi-dev1.azurewebsites.net/",
    EtlApiBaseUrl: "https://appsvc-remitter-etlapi-dev1-f0d5erg2cnhpebhy.westus-01.azurewebsites.net/",
    CreditorPortalApiBaseUrl: "https://creditorportal-api-dev1.remitter.com/",
    CampaignsApiUrl: 'https://campaignsapi-dev1.remitter.com/',
};
